import React from 'react';
import './Footer.css'
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer'>
      <div className='footer-content'>
        <Link to='/' className='footer-logo'><img src={require('../img/main_logo_600px.png')}></img></Link>
        <div className='contact'>
          {/* <h3 className='no-show-mobile'>Grace Community Fellowship</h3> */}
          <Link to='https://maps.app.goo.gl/VK5cafZKUHgjTYga7' target='blank' className='footer-link'>
          <p><i className="fa fa-map-marker-alt fa-fw"></i> 7600 West State Highway 29</p>
          <p><i className="fa fa-map-marker-alt fa-fw invisible"></i> Georgetown, TX 78628</p>
          </Link>
          <br/>
          <Link to='tel:512-591-8733' className='footer-link disabled'>
          <p><i className='fa fa-phone fa-rotate-90 fa-fw'></i> 512 591 8733</p>
          </Link>
          <br/>
          <Link to='mailto:info@gcftx.org?' className='footer-link'>
          <p><i className='fa fa-envelope fa-fw'></i> info@gcftx.org</p>
          </Link>
          <br/>
          <Link to='https://www.youtube.com/@gcfmedia5203' target='blank' className='footer-link icon'>
          <p><i className='fa fa-brands fa-youtube fa-fw fa-lg'></i> YouTube</p>
          </Link>
          <Link to='https://www.sermonaudio.com/source_detail.asp?sourceid=gcftx' target='blank' className='footer-link icon'>
          <p><i className='fa fa-microphone fa-fw fa-lg'></i>Sermon Audio</p>
          </Link>
        </div>
      </div>
      <div className='under-footer'>
      © 2026 Grace Community Fellowship. All Rights Reserved.
      </div>
      
    </div>
  )
}

export default Footer
